import Amplify, { Auth } from 'aws-amplify';

import config from '../amplify/config.js';

export default () => {
  Amplify.configure(config)
  return Auth.signUp({})
};
